import { createI18n } from '@calendly/i18n'
import { Settings } from '@calendly/datetime'

export const { i18n, useI18n } = createI18n({
  de: () => import('./de.locale.js'),
  en: () => import('./en.locale.js'),
  es: () => import('./es.locale.js'),
  fr: () => import('./fr.locale.js'),
  it: () => import('./it.locale.js'),
  nl: () => import('./nl.locale.js'),
  pt: () => import('./pt.locale.js'),
  uk: () => import('./uk.locale.js')
})

export const withI18n = (Component) => (props) => {
  const { i18n: i18nProp } = useI18n()

  return <Component {...props} i18n={i18nProp} />
}

i18n.onCurrentLocaleChange(() => {
  Settings.defaultLocale = i18n.locale
})
